class SuggestController {
    init() {
        document.querySelectorAll('form[data-suggest]').forEach(form => {
            const serviceUrl = form.dataset.suggest;
            const searchBox  = form.querySelector('.tx-solr-suggest') || form;
            const input      = form.querySelector('.tx-solr-suggest-focus');
            const container  = form.querySelector('.tx-solr-autocomplete') || document.body;

            // Prevent browsers from auto-filling the input
            if (input) input.autocomplete = 'off';

            // Prevent submit of empty search form
            form.addEventListener('submit', e => {
                if (!input.value.trim()) {
                    e.preventDefault();
                    input.focus();
                }
            });

            // Remove any existing dropdown
            if (form._autocompleteDropdown) form._autocompleteDropdown.remove();

            // Create dropdown container
            const dropdown         = document.createElement('div');
            dropdown.className     = 'autocomplete-suggestions tx-solr-autosuggest';
            dropdown.style.display = 'none';
            container.appendChild(dropdown);
            form._autocompleteDropdown = dropdown;

            let suggestions = [];
            let highlightedIndex = -1;

            const escapeRegex = str => str.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&');
            const escapeHtml = str => str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');

            function formatResult(sug, currentValue) {
                if (!currentValue) {
                    return escapeHtml(sug.value);
                }
                const pattern = new RegExp(`(${escapeRegex(currentValue.trim())})`, 'gi');
                return escapeHtml(sug.value).replace(pattern, '<strong>$1</strong>');
            }

            function selectSuggestion(sug) {
                input.value = sug.value;
                dropdown.style.display = 'none';
                searchBox.parentElement.classList.remove('autocomplete-active');
                form.submit();
            }

            function renderSuggestions() {
                dropdown.innerHTML = '';
                if (!suggestions.length) {
                    dropdown.style.display = 'none';
                    searchBox.parentElement.classList.remove('autocomplete-active');
                    return;
                }

                const list = document.createElement('ul');

                suggestions.forEach((sug, index) => {
                    const li = document.createElement('li');
                    li.className = 'autocomplete-suggestion';
                    li.innerHTML = formatResult(sug, input.value);
                    if (index === highlightedIndex) {
                        li.classList.add('autocomplete-selected');
                    }
                    li.addEventListener('mousedown', () => selectSuggestion(sug));
                    list.appendChild(li);
                });
                dropdown.appendChild(list);

                dropdown.style.display = 'block';
                searchBox.parentElement.classList.add('autocomplete-active');
            }

            // Fetch suggestions on input
            input.addEventListener('input', () => {
                const query = input.value;
                if (!query) {
                    suggestions = [];
                    renderSuggestions();
                    return;
                }

                fetch(`${serviceUrl}?tx_solr[queryString]=${encodeURIComponent(query)}`, {
                    credentials: 'same-origin'
                })
                .then(res => res.json())
                .then(response => {
                    suggestions = [];
                    let firstValue = null;
                    if (response.suggestions) {
                        Object.entries(response.suggestions).forEach(([text, count]) => {
                            if (firstValue === null) firstValue = text;
                            suggestions.push({ value: text, data: { category: 'suggestion', count } });
                        });
                    }
                    if (response.documents) {
                        response.documents.forEach(doc => {
                            const dataObj = { ...doc };
                            const defaultGroup = form.dataset.suggestHeader || 'Top results';
                            dataObj.category = dataObj.group ? (form.dataset['suggestHeader' + dataObj.group] || dataObj.group) : defaultGroup;
                            suggestions.push({ value: firstValue, data: dataObj });
                        });
                    }
                    highlightedIndex = -1;
                    renderSuggestions();
                });
            });

            // Keyboard navigation
            input.addEventListener('keydown', e => {
                if (dropdown.style.display === 'none') return;
                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        highlightedIndex = Math.min(highlightedIndex + 1, suggestions.length - 1);
                        renderSuggestions();
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        highlightedIndex = Math.max(highlightedIndex - 1, 0);
                        renderSuggestions();
                        break;
                    case 'Enter':
                        e.preventDefault();
                        if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
                            selectSuggestion(suggestions[highlightedIndex]);
                        } else {
                            form.submit();
                        }
                        break;
                    case 'Escape':
                        dropdown.style.display = 'none';
                        searchBox.parentElement.classList.remove('autocomplete-active');
                        break;
                }
            });

            input.addEventListener('blur', () => {
                dropdown.style.display = 'none';
                searchBox.parentElement.classList.remove('autocomplete-active');
            });
        });
    }
}

export const initSuggest = () => {
    const solrSuggestController = new SuggestController();
    
    solrSuggestController.init();
    document.body.addEventListener('tx_solr_updated', () => {
        solrSuggestController.init();
    });
}
